import React, { useEffect, useState } from 'react';
import { string, object, bool } from 'prop-types';
import { Modal, Tabs } from 'antd';
import moment from 'moment';
import CallHistoryTable from './CallHistoryTable';
import { orderBy, get, map, includes, isEmpty, split, capitalize } from 'lodash';
import Truncate from '../../shared/Truncate';
import { Text, Loading, If, NotFound, FlexContainer, ConditionalRender, Row, Image, Icon, AudioPlayer, Column, AppIcon } from '../../common';
import styled, { css } from 'styled-components';
import { ANDROID_GREEN, GRAY_DARK, BLACK, PLATINUM, DARK_CHARCOAL, ARGENT } from '../../../utils/colors';
import { Query } from '../../graphql';
import GET_ORDER_COMMENTS from '../../../queries/GET_ORDER_COMMENTS';
import GET_ORDER_LOGBOOK from '../../../queries/GET_ORDER_LOGBOOK';
import GET_RECORD_BY_ITEM_ID from '../../../queries/GET_RECORD_BY_ITEM_ID';
import { genUUID } from '../../../utils/misc';
import OptimalSubstitutes from './OptimalSubstitutes';
import CustomerSelection from './CustomerSelection';
import GetCommentsbyOrderId from '../../../components/graphql/getOrderComments';

const TabPane = Tabs.TabPane;

const defaultCellStyle = {
    padding: '9px',
    borderBottom: '1px solid #eaeaea',
    whiteSpace: 'nowrap'
};

const historyCallStyles = {
    tdStyle: defaultCellStyle,
    thStyle: { ...defaultCellStyle, backgroundColor: PLATINUM }
};

const historyCallStylesIsAudit = {
    tdStyle: {
        padding: '9px',
        fontWeight: "400",
        fontSize: 14,
    },
    thStyle: {
        padding: '9px',
        fontWeight: "700",
        fontSize: 14,
    }
}

const BubbleContainer = styled.div`
    padding: 10px;
    /* max-width: 70%;  */
    ${({ sender, isAudit }) => {
        if (sender === 'shopper') {
            return css`
                background-color: #f0f0f0;
                margin-right: ${isAudit ? 'auto' : undefined};
                margin-left: ${isAudit ? undefined : 'auto'};
                border-radius: ${isAudit ? "12px 12px 12px 0px" : "30px 7px 7px 0px"};
                `;
        }
        return css`
            background-color: #d9f7be;
            margin-left: ${isAudit ? 'auto' : undefined};
            border-radius: ${isAudit ? "12px 12px 0px 12px" : "7px 30px 0px 7px"};
            `;
    }}
`;

const HR = styled.hr`
    width: calc(50% - 75px);
    border: 0;
    border-top: 1px solid ${GRAY_DARK};
    margin: 7px 0;
`;
//para audit por problemas de margenes agregados con Ant Design.
const TabsContainer = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
`;

const TabHeader = styled.div`
  background-color: ${props => props.isActive ? 'white' : '#f0f0f0'};
  border-bottom: 2px solid #d9d9d9;
  border-radius: 8px 8px 0 0;   
  padding: 8px;
  cursor: pointer;
  min-height: max-content;
  min-width: max-content;
  transition: all 0.2s ease;
  margin-bottom: -16px;
  color: ${props => props.isActive ? '#000000' : '#888888'};
  
  &:hover {
    padding: 8px;
    background-color: ${props => props.isActive ? 'white' : '#fafafa'};
    span {
        color: ${props => props.isActive ? '#000000' : '#888888'};
    }
  }
  span {
    width: 100%;
    size: 15px;
    font-weight: 700;
    line-height: 27px;

  }
`;


const senderResolver = sender => {
    const users = {
        'shopper': 'Picker',
        'client': 'Cliente'
    };
    return users[sender];
};



const ChatBubble = ({ message, sender, contentType, imageObject, onClick, date, status, substitutes, itemOriginal, substitution, cancel, isAudit }) => {
    const messageWasRead = status === 'read';

    const dateResolver = () => {
        if (typeof date === 'object') {
            return moment.unix(get(date, 'seconds', 0)).format('HH:mm');
        }
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
    };

    const contentResolver = () => {
        switch (contentType) {
            case 2:
                return <Image src={imageObject} maxHeight={200} maxWidth={500} onClick={onClick} style={{ cursor: 'pointer' }} />;
            case 3:
                const optimalSubstitutesProps = {
                    substitutes,
                    itemOriginal
                };
                return <OptimalSubstitutes {...optimalSubstitutesProps} />;
            case 4:
                const customerSelectionProps = {
                    itemOriginal,
                    substitution,
                    cancel
                };
                return <CustomerSelection {...customerSelectionProps} />;
            default:
                return (
                    <>
                        {contentType === 2 ?
                            <Image src={imageObject} maxHeight={200} maxWidth={500} onClick={onClick} style={{ cursor: 'pointer' }} />
                            :
                            <Text text={message} />
                        }
                    </>
                );
        };
    };
    if (!isAudit) {
        return (
            <FlexContainer mB={10} direction='column'>
                <Row justify={sender === 'shopper' ? 'flex-start' : 'flex-end'}>
                    <BubbleContainer sender={sender}>
                        <Row>
                            <Text text={senderResolver(sender)} strong />
                        </Row>
                        {contentResolver()}
                        <Row justify='end' align='center'>
                            <Text size={12} color='#888888' text={dateResolver()} />
                            <Icon name={`msg-${messageWasRead ? 'delivered' : status}`} color={messageWasRead ? ANDROID_GREEN : BLACK} left={8} />
                        </Row>
                    </BubbleContainer>
                </Row>
            </FlexContainer>
        )
    }
    return (
        <FlexContainer mB={8} direction='column' width="100%">
            <FlexContainer justify={sender === 'shopper' ? 'flex-start' : 'flex-end'}>
                <BubbleContainer sender={sender} isAudit>
                    <Row>
                        <Text text={senderResolver(sender)} strong />
                    </Row>
                    {contentResolver()}
                    <Row justify='end' align='center' textAlign='center'>
                        <Text size={12} color='#888888' text={dateResolver()} />
                        <AppIcon name={messageWasRead ? 'ic-msg-delivered' : "ic-msg-sent"} fill={messageWasRead ? ANDROID_GREEN : BLACK} left={8} size={messageWasRead ? 16 : 10} />
                    </Row>

                </BubbleContainer>
            </FlexContainer>
        </FlexContainer >
    );
};


const ChatModal = ({ visible, onClose, chat, pickerName, clientName }) => {
    return (
        <Modal
            title={<div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: "8px" }}>
                <div style={{ width: '100%' + '48px', height: 48, borderBottom: '2px solid #DDECB2', textAlign: 'center', padding: "0px -24px" }}>
                    <Text text='Historial de Chat' strong size={16} />
                </div>
                {clientName && (<span>
                    <Text text={'Nombre cliente:'} size={14} /><Text text={clientName} size={14} strong />
                </span>
                )}
                {pickerName && (<span>
                    <Text text={'Nombre picker:'} size={14} /><Text text={pickerName} size={14} strong />
                </span>
                )}
                <div style={{ width: "100%", height: '2px', borderBottom: `1px solid #000000` }} />
            </div>}
            visible={visible}
            onClose={onClose}
            onCancel={onClose}
            footer={null}
            width={"90vw"}
            maxHeight={"80vh"}
            style={{ top: 20 }}

        >
            <FlexContainer
                direction='column'
                style={{
                    maxHeight: 'calc(80vh - 100px)',
                    overflowY: 'auto',
                    padding: '15px 20px'
                }}
            >

                {map(chat, (message, index) => {
                    const dayIsAfter = moment(get(message, 'date')).isAfter(
                        moment(get(chat[index - 1], 'date')), 'day'
                    );
                    return (
                        <React.Fragment key={`chat-full-${index}`}>
                            <If
                                condition={dayIsAfter}
                                then={
                                    <FlexContainer align='center' justify='center' mY={15}>
                                        <Text
                                            text={moment(get(message, 'date')).format('DD [de] MMMM')}
                                            color={GRAY_DARK}
                                            strong
                                            size={12}
                                        />
                                    </FlexContainer>
                                }
                            />
                            <ChatBubble {...message} isAudit />
                        </React.Fragment>
                    );
                })}
            </FlexContainer>
        </Modal>
    );
};


const CallHistory = ({ callHistoryType, orderId, firebase, isWhatsapp, isAudit = undefined, picker = undefined, client = undefined }) => {
    const fromCallAndChatHistory = includes('shopper_calls', callHistoryType);
    const [calls, setCalls] = useState([]);
    const [chat, setChat] = useState([]);
    const [filterKey, setFilterKey] = useState(isAudit ? 'picker' : 'calls');
    const [showImage, setShowImage] = useState(null);
    const [showChatModal, setShowChatModal] = useState(false);
    const modalNames = {
        picker,
        client
    }
    const callDocResolver = ({ call }) => {
        const getDataField = field => get(call, field, 'N/A');
        // Los Timestamp de Firestore se pasan a segundos explicitamente: desde firebase v8
        // su valueOf() cuenta desde el año 1, y moment(..., 'X') los leeria con 1969 años de mas.
        const getTimeField = field => {
            const value = getDataField(field);
            return get(value, 'seconds', value);
        };
        return {
            clientPhone: getDataField('clientPhone'),
            event: getDataField('event'),
            os: getDataField('os'),
            shopperEmail: getDataField('shopperEmail'),
            callStart: getTimeField('callStart'),
            callEnd: getTimeField('callEnd')
        };
    };

    const senderResolver = sender => split(sender, '-')[1] || 'client';

    const chatDocResolver = ({ contentType, date, imageObject, textObject, identifier, status, ...elements }) => ({
        contentType,
        date,
        imageObject: get(imageObject, 'url', null),
        message: get(textObject, 'message', ''),
        sender: senderResolver(identifier),
        onClick: () => setShowImage(get(imageObject, 'url', null)),
        status,
        itemOriginal: get(elements, 'itemOriginal', null),
        substitutes: get(elements, 'substitutes', null),
        substitution: get(elements, 'substitution', null),
        cancel: get(elements, 'cancel', false)
    });

    useEffect(() => {
        let unsubscribeChat = () => { };
        let unsubscribeLog = () => { };

        if (fromCallAndChatHistory) {
            const chatCollectionName = isWhatsapp
                ? 'clientShopperChatWhatsApp'
                : 'clientShopperChat';
            unsubscribeChat = firebase.collection(chatCollectionName)
                .doc(orderId)
                .collection('messages')
                .onSnapshot(({ docs }) => {
                    if (!isEmpty(docs)) {
                        setChat(map(docs, doc => chatDocResolver(doc.data())));
                    } else {
                        setChat([]);
                    }
                });

            unsubscribeLog = firebase.collection('order-logs')
                .doc(orderId)
                .collection('calls')
                .onSnapshot(({ docs }) => {
                    const getCalls = map(docs, doc => {
                        const data = doc.data();
                        return callDocResolver(data);
                    });
                    setCalls(getCalls);
                });
        }

        return () => {
            unsubscribeLog();
            unsubscribeChat();
        };
    }, [fromCallAndChatHistory, firebase, orderId, isWhatsapp]);

    const onChangeTab = (key) => setFilterKey(key);

    const getColumns = () => {
        const columns = {
            call_history: [
                {
                    title: 'Fecha',
                    dataIndex: 'createdAt',
                    key: 'createdAt',
                    thStyle: { width: '120px', ...defaultCellStyle },
                    tdStyle: defaultCellStyle,
                    render: (value) => <Text nowrap text={value} />
                },
                {
                    title: 'Origen',
                    dataIndex: 'dataSource',
                    key: 'dataSource',
                    thStyle: { width: '45px', ...defaultCellStyle },
                    tdStyle: defaultCellStyle,
                    render: value => <Text text={value} />
                },
                {
                    title: 'Usuario',
                    dataIndex: 'user',
                    key: 'user',
                    thStyle: { width: '200px', ...defaultCellStyle },
                    tdStyle: defaultCellStyle,
                    render: value => <Truncate maxWidth={200}><Text nowrap text={value} /></Truncate>
                },
                {
                    title: 'Mensajes',
                    dataIndex: 'comment',
                    key: 'comment',
                    thStyle: defaultCellStyle,
                    tdStyle: defaultCellStyle,
                    render: value => (
                        <div>
                            <Text text={value} />
                        </div>
                    )
                }
            ],
            shopper_calls: [
                {
                    title: <Text text={"Fecha"} size={14} strong />,
                    dataIndex: 'creationTime',
                    key: 'date',
                    ...(isAudit ? historyCallStylesIsAudit : historyCallStyles),
                    render: value => {
                        return <Text text={moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY')} size={14} />;
                    }
                },
                {
                    title: <Text text={'Hora'} size={14} strong />,
                    dataIndex: 'creationTime',
                    key: 'hour',
                    ...(isAudit ? historyCallStylesIsAudit : historyCallStyles),
                    render: value => <Text text={moment(value, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')} size={14} />
                },
                {
                    title: <Text text={"Duración"} size={14} strong />,
                    dataIndex: 'duration',
                    key: 'duration',
                    ...(isAudit ? historyCallStylesIsAudit : historyCallStyles),
                    render: value => <Text text={value} size={14} />
                },
                {
                    title: <Text text={"Contacto"} size={14} strong />,
                    dataIndex: 'status',
                    key: 'status',
                    ...(isAudit ? historyCallStylesIsAudit : historyCallStyles),
                    render: value => <Text text={value} size={14} />
                },
            ]
        };
        return get(columns, callHistoryType, get(columns, 'call_history'));
    };

    const tabs = [
        { key: 'calls', label: 'Historial llamadas' },
        { key: 'chat', label: 'Historial Chat' },

    ];
    const tabsAudit = [
        { key: 'picker', label: 'Comentario Picker' },
        { key: 'calls', label: 'Historial llamadas' },
        { key: 'chat', label: 'Historial Chat' },
        // { key: 'client', label: 'Comentario cliente' },

    ];

    const queryProperties = fromCallAndChatHistory
        ? {
            key: 'records',
            query: GET_RECORD_BY_ITEM_ID,
            variables: { itemId: orderId }
        }
        : {
            key: 'comments',
            query: callHistoryType === 'logbook' ? GET_ORDER_LOGBOOK : GET_ORDER_COMMENTS,
            keyGetData: callHistoryType === 'logbook' ? 'getLogByOrderId' : 'getCommentsbyOrderId',
            variables: { orderId },
            skip: fromCallAndChatHistory
        };
    const CustomTabHeader = ({ tabs, activeKey, onTabChange, children }) => {
        return (
            <TabsContainer>
                {map(tabs, ({ key, label }) => (
                    <TabHeader
                        key={key}
                        isActive={activeKey === key}
                        onClick={() => onTabChange(key)}
                    >
                        <span style={{
                            textWrap: 'nowrap'
                        }}>{label}</span>
                    </TabHeader>
                ))}
            </TabsContainer>
        );
    };

    // This method merge shopper calls from Firebase & shopper calls from Messagebird
    const shopperCallsResolver = (recordsByOrderIdInput) => {
        // This method lets to parse calls from firebase and make it compatible with MessageBird calls at redering moment.
        const callsFromFirebase = map(calls, ({ callStart, shopperEmail, clientPhone, ...fields }) => ({
            ...fields,
            id: genUUID(),
            pickerId: shopperEmail,
            destinationNumber: clientPhone,
            creationTime: moment(callStart, 'X').format('DD-MM-YYYY HH:mm'),
            duration: (() => {
                if (callStart === 'N/A') return 'Solo hay registro del fin de llamada';
                const start = moment(callStart, 'X');
                const end = moment(get(fields, 'callEnd', moment()), 'X');
                return moment(end.diff(start, 'X')).format('mm:ss');
            })(),
            status: (() => {
                const start = moment(callStart, 'X');
                const end = moment(get(fields, 'callEnd', moment()), 'X');
                const getTimeUnit = unit => parseInt(moment(end.diff(start, 'X')).format(unit));
                return ((getTimeUnit('mm') > 0) || (getTimeUnit('ss') > 30)) ? 'Exitoso' : 'Intento de contacto';
            })(),
            url: false,
            fromFirebase: true
        }));
        const callsFromMessageBird = get(recordsByOrderIdInput, 'recordByItemId.data', []);
        const shopperCalls = orderBy([...callsFromFirebase, ...callsFromMessageBird], 'creationTime', 'asc');
        return shopperCalls;
    };

    return (<Query {...queryProperties} fetchPolicy='network-only'>
        {({ data: graphData, loading }) => {
            const data = get(queryProperties, 'key') === 'comments'
                ? orderBy(get(graphData, `${get(queryProperties, 'keyGetData')}.results`, []), 'createdAt', 'desc')
                : shopperCallsResolver(graphData);
            const sortedChat = orderBy(chat, (msg) => moment(msg.date), 'asc');
            const chatPreview = sortedChat.slice(-2);
            const hasMoreMessages = sortedChat.length > 2;

            return (
                <Loading loading={loading}>
                    <Modal title={null} visible={showImage} onClose={() => { setShowImage(null) }} onCancel={() => setShowImage(null)}>
                        <Image src={showImage} maxHeight={700} />
                    </Modal>
                    {picker && client && <ChatModal
                        visible={showChatModal}
                        onClose={() => setShowChatModal(false)}
                        chat={sortedChat}
                        orderId={orderId}
                        pickerName={modalNames.picker}
                        clientName={modalNames.client}
                    />}

                    <FlexContainer direction='column' flex={1} style={{ borderRadius: "0 0 12px 12px", overflow: 'hidden' }}>
                        <ConditionalRender condition={fromCallAndChatHistory}>
                            {isAudit ? (<CustomTabHeader
                                tabs={tabsAudit}
                                activeKey={filterKey}
                                onTabChange={onChangeTab}
                            />)
                                :
                                (<FlexContainer display='block' mX={-28} mB={17}>
                                    <Tabs defaultActiveKey='calls' onChange={onChangeTab}>
                                        {map(tabs, ({ key, label }) => <TabPane tab={<Text strong text={label} color={filterKey === key ? DARK_CHARCOAL : ARGENT} />} key={key} />)}
                                    </Tabs>
                                </FlexContainer>)}
                        </ConditionalRender>
                        <ConditionalRender condition={filterKey === 'calls'}>
                            <If
                                condition={isEmpty(data)}
                                then={<NotFound firstTextLine='Este pedido no tiene llamadas registradas' />}
                                else={
                                    isAudit ?
                                        <div style={{ backgroundColor: '#FFFFFF', height: '100%', width: "100%" }}>
                                            <CallHistoryTable
                                                columns={getColumns()}
                                                data={data}
                                            />
                                        </div> : (<CallHistoryTable
                                            columns={getColumns()}
                                            data={data}
                                        />)
                                }
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={filterKey === 'chat'}>
                            <If
                                condition={isEmpty(chat)}
                                then={<NotFound firstTextLine='Este pedido no tiene chat registrado' />}
                                else={isAudit ?
                                    (
                                        <FlexContainer
                                            direction='column'
                                            flex={1}
                                            style={{
                                                height: '100%',
                                                width: '100%',
                                                maxHeight: '240px',
                                                backgroundColor: 'white',
                                                padding: '5px 10px 10px 10px',
                                                gap: '2px'
                                            }}
                                        >
                                            <FlexContainer direction='column' flex={1} style={{ overflowY: 'scroll', height: "100%" }}>
                                                {map(chatPreview, (message, index) => (
                                                    <ChatBubble key={`chat-preview-${index}`} {...message} isAudit />
                                                ))}
                                            </FlexContainer>
                                            <If
                                                condition={hasMoreMessages}
                                                then={
                                                    <FlexContainer >
                                                        <a
                                                            onClick={() => setShowChatModal(true)}
                                                            style={{
                                                                textDecoration: 'underline',
                                                                cursor: 'pointer',
                                                                fontWeight: 700,

                                                                fontSize: '12px',
                                                                color: '#068503'
                                                            }}
                                                        >
                                                            Expandir Chat
                                                        </a>
                                                    </FlexContainer>
                                                }
                                            />
                                        </FlexContainer>
                                    ) : (
                                        <FlexContainer
                                            border='1px solid #eaeaea'
                                            // mT={50}
                                            borderRadius={5}
                                            padding={16}
                                            style={{ maxHeight: 'calc(100vh - 200px)' }}
                                        >
                                            <FlexContainer direction='column' flex={1} overflowY>
                                                {map(chat, (message, index) => {
                                                    const dayIsAfter = moment(get(message, 'date'), 'YYYY-MM-DD').isAfter(moment(get(chat[index - 1], 'date'), 'YYYY-MM-DD'));
                                                    return (
                                                        <>
                                                            <If
                                                                condition={dayIsAfter}
                                                                then={
                                                                    <FlexContainer align='center' justify='space-between' pT={10} pB={20}>
                                                                        <HR />
                                                                        <FlexContainer>
                                                                            <Text text={moment(get(message, 'date'), 'YYYY-MM-DD').format('DD [de] MMMM')} color={GRAY_DARK} strong />
                                                                        </FlexContainer>
                                                                        <HR />
                                                                    </FlexContainer>
                                                                }
                                                            />
                                                            <ChatBubble {...message} />
                                                        </>
                                                    );
                                                })}
                                            </FlexContainer>
                                        </FlexContainer>
                                    )
                                }
                            />
                        </ConditionalRender>
                        <ConditionalRender condition={filterKey === 'picker'}>
                            <If
                                condition={isEmpty(data)}
                                then={<NotFound firstTextLine='Este pedido no tiene comentarios de picker registrados' />}
                                else={
                                    <GetCommentsbyOrderId variables={{ orderId }} fetchPolicy='network-only'>
                                        {({ data, loading }) => {
                                            const comments = data?.length > 0 && data?.filter(item => item?.contactType === 11);
                                            return (
                                                <Loading loading={loading}>
                                                    <Column style={{ gap: 6, width: "100%", height: "100%", backgroundColor: 'white', padding: '15px 20px 15px 20px' }}>
                                                        {comments?.length > 0 && comments.map(coment => (<Text size={12} text={`- ${coment.comment}`} />))}
                                                    </Column>
                                                </Loading>
                                            );
                                        }}
                                    </GetCommentsbyOrderId>
                                }
                            />
                        </ConditionalRender>
                        {/* <ConditionalRender condition={filterKey === 'client'}>
                            <If
                                condition={isEmpty(data?.filter(item => item?.contactType === 8))}
                                then={<NotFound firstTextLine='Este pedido no tiene comentarios de cliente registrados' />}
                                else={
                                    <GetCommentsbyOrderId variables={{ orderId }} fetchPolicy='network-only'>
                                        {({ data, loading }) => {
                                            const comments = data?.filter(item => item?.contactType === 8);
                                            return (
                                                <Loading loading={loading}>
                                                    <Row padding='5px 10px 5px 10px' style={{ flex: '0 1 auto', backgroundColor: 'white', height: '100%' }}>
                                                        <Column style={{ borderRadius: 8 }}>
                                                            {comments?.length > 0 && comments.map(coment => (
                                                                <Text text={coment?.comment} size={11} color='#848484' style={{ maxHeight: '170px', overflowY: 'auto', padding: 5 }} />
                                                            ))}
                                                        </Column>
                                                    </Row>
                                                </Loading>
                                            );
                                        }}
                                    </GetCommentsbyOrderId>
                                }
                            />
                        </ConditionalRender> */} 
                        {/* comentado temporalmente   */}
                    </FlexContainer>
                </Loading >
            );
        }}
    </Query >
    );
};

CallHistory.propTypes = {
    callHistoryType: string,
    orderId: string,
    firebase: object,
    isWhatsapp: bool
};

export default CallHistory;